import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserModel } from '../Api_Module';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const roles = next.data['allowedRoles'] as Array<string>;
      if (!!localStorage.getItem('currentUser')) {
        // logged in so return true
        const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
        const isAllowedAccess = roles.length < 1 || !!roles.find((role) => !!role && !!user.role && role.toLowerCase() === user.role.toLocaleLowerCase());
        if (isAllowedAccess) {
          return true;
        }
        this.router.navigate(['/pagenotfound']);
        return false;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
    return false;
  }
}
